import React from 'react';
import { useTranslation } from 'react-i18next';

const EppromtDoc = () => {
  const { t } = useTranslation('help');

  return (
    <div style={styles.container}>
      {/* Title */}
      <h2 style={styles.title}>
        {t('eppromptDoc.title', 'Secure Prompt and DoC')}
      </h2>

      {/* Section (a) */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(a)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('eppromptDoc.labels.purpose', 'Purpose:')}{' '}
            </strong>
            {t(
              'eppromptDoc.descriptions.purpose',
              'This secure simulator endpoint allows Prompts & Docs WhiteHaX tester to test Malicious Prompts & Docs aginast a secure handler which blocks (filters out) majority of malicious prompts & docs & rejects them with an appropriate response to simulate secure handling of such malicious data inserstion attempts.'
            )}
          </p>
        </div>
      </div>

      {/* Section (b) */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(b)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('eppromptDoc.labels.endpointUrl', 'EndPoint URL:')}
            </strong>
          </p>
          <div style={styles.urlContainer}>
            <a
              href="http://52.53.127.59:5000/detector"
              style={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              http://52.53.127.59:5000/detector
            </a>
          </div>
        </div>
      </div>

      {/* Section (c) - Request Json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(c)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('eppromptDoc.labels.requestJson', 'Request Json:-')}{' '}
            </strong>
            {t(
              'eppromptDoc.descriptions.requestJson',
              'This is the Request JSON template to send test prompts & malicious docs to the Secure Simulator Endpoint. Configure headers, body, prompt insertion path, and data type.'
            )}
          </p>
          <ul style={styles.bulletList}>
            <li style={styles.bulletItem}>
              {t(
                'eppromptDoc.descriptions.bullet1',
                'Use placeholders such as prompt insertion fields exactly as the WhiteHaX UI expects.'
              )}
            </li>
            <li style={styles.bulletItem}>
              {t(
                'eppromptDoc.descriptions.bullet2',
                'Keep auth headers current and avoid pasting long-lived secrets into screenshots or shared docs.'
              )}
            </li>
            <li style={styles.bulletItem}>
              {t(
                'eppromptDoc.descriptions.bullet3',
                'If Request format does not match what the simulator expects, it will reject them with HTTP 401 error codes.'
              )}
            </li>
          </ul>

          {/* Request JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"headers"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"Authorization"</span>: <span style={styles.jsonString}>"Bearer xxx"</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"Content-Type"</span>: <span style={styles.jsonString}>"application/json"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"data_type"</span>: <span style={styles.jsonString}>"form"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"request_template"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"user_input"</span>: <span style={styles.jsonString}>"{"{{PROMPT}}"}"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"prompt_path"</span>: <span style={styles.jsonString}>"user_input"</span>
            </div>
            <div>{'}'}</div>
          </div>
        </div>
      </div>

      {/* Section (c) - Response Json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(c)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t('eppromptDoc.labels.responseJson', 'Response Json:-')}{' '}
            </strong>
            {t(
              'eppromptDoc.descriptions.responseJson',
              'This is the response JSON format received By WhiteHaX tester when a malicious prompt or doc is sent to the Secure Psimulator Endpoint. It maps the actual response body field that contains the response for WhiteHaX Tester to analyze and correspondingly update/adjust the test results.'
            )}
          </p>

          {/* Response JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"category"</span>: <span style={styles.jsonString}>"input_output_risk"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"detected_at"</span>: <span style={styles.jsonString}>"2026-03-23T19:25:13.839740+00:00"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"evidence"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"bias_hits"</span>: [],
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"confidential_matches"</span>: [],
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"pii_matches"</span>: [],
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"toxicity_score"</span>: <span style={styles.jsonNumber}>0.05</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"evidence_note"</span>: [
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonString}>"No significant input/output risks detected."</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonString}>""</span>
            </div>
            <div style={styles.indent1}>],</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"flags"</span>: [],
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"recommended_actions"</span>: [],
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"response"</span>: <span style={styles.jsonString}>"{"{{RESP}}"}"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"scores"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"bias"</span>: <span style={styles.jsonNumber}>0.0</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"confidential_leakage"</span>: <span style={styles.jsonNumber}>0.0</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"pii_leakage"</span>: <span style={styles.jsonNumber}>0.0</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"toxicity"</span>: <span style={styles.jsonNumber}>0.05</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"severity"</span>: <span style={styles.jsonNumber}>0.0125</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"threat_detected"</span>: <span style={styles.jsonBoolean}>true</span>
            </div>
            <div>{'}'}</div>
          </div>
        </div>
      </div>

      {/* Section (c) - Expected Test Results */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(c)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>
              {t(
                'eppromptDoc.labels.expectedResults',
                'Expected Test Results against this simulator:-'
              )}{' '}
            </strong>
            {t(
              'eppromptDoc.descriptions.expectedResults',
              'Since this simulator simulates a secure Prompts & Doc handler logic, the expected readiness result scores for all categories should be 90% or more.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

// Component Styles (Dark Theme)
const styles = {
  container: {
    maxWidth: '850px',
    margin: '0 auto',
    padding: '20px',
    color: '#e0e0e0',
    backgroundColor: 'transparent'
  },
  title: {
    margin: '0 0 20px 0',
    fontWeight: 'bold',
    color: '#ffffff'
  },
  section: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '15px'
  },
  sectionLabel: {
    width: '30px',
    flexShrink: 0,
    color: '#a0a0a0'
  },
  sectionContent: {
    flexGrow: 1
  },
  paragraph: {
    margin: '0 0 10px 0',
    lineHeight: '1.5',
    color: '#d0d0d0'
  },
  strongText: {
    color: '#ffffff'
  },
  urlContainer: {
    textAlign: 'center',
    margin: '10px 0 20px 0'
  },
  link: {
    color: '#63a4ff',
    textDecoration: 'underline'
  },
  bulletList: {
    margin: '0 0 15px 0',
    paddingLeft: '20px',
    listStyleType: 'disc',
    color: '#d0d0d0'
  },
  bulletItem: {
    marginBottom: '5px',
    lineHeight: '1.4'
  },
  codeBlock: {
    backgroundColor: '#111318',
    color: '#e0e0e0',
    padding: '15px 20px',
    margin: '15px 0',
    borderRadius: '4px',
    border: '1px solid #2a2d34',
    overflowX: 'auto',
    whiteSpace: 'pre'
  },
  indent1: {
    paddingLeft: '20px'
  },
  indent2: {
    paddingLeft: '40px'
  },
  jsonKey: {
    color: '#6fc2ef'
  },
  jsonString: {
    color: '#e59373'
  },
  jsonNumber: {
    color: '#b5cea8'
  },
  jsonBoolean: {
    color: '#569cd6'
  }
};

export default EppromtDoc;